<div
  class="pointer-events-none"
  [ngStyle]="contentStyle"
  [ngClass]="[
    baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : '',
    selectedTextStyleClass
  ]"
>
  @if (dataIn?.attri?.widgetProperties?.['orientation'] === Orientation.HORIZONTAL) {
  <div class="w-100">
    @if (documentDetails.length > 0 && !appBuilderShowNoRecordsContent && !appBuilderShowFetchingContent) {
    <finxone-web-frontend-common-carousel
      [documentsData]="documentDetails"
      [templateFunction]="documentListTemplateFunction"
      [activeAccountIndex]="0"
      [widgetName]="widgetName"
      [carouselItemHeight]="carouselItemStyles?.height ?? 'auto'"
      [carouselItemWidth]="carouselItemStyles?.width ?? 'auto'"
      [carouselItemWidthUnit]="carouselItemStyles?.widthUnit ?? '%'"
      [isDisabled]="isDownloading"
      (itemClicked)="onClickDocument($event)"
    ></finxone-web-frontend-common-carousel>
    } @else {
    <ng-container [ngTemplateOutlet]="documentStateTemplate"></ng-container>
    }
  </div>
  } @else {
  <div
    [ngStyle]="{ maxHeight: containerHeight }"
    id="document-list"
    class="transaction-card w-100"
    (scroll)="onScroll($event)"
  >
    @if (documentDetails.length > 0 && !appBuilderShowNoRecordsContent && !appBuilderShowFetchingContent) {
    <ng-container>
      @for (document of documentDetails; track document?.id;) {
      <div
        (click)="onClickDocument(document)"
        class="d-flex"
        [class.disabled]="isDownloading && documentId === document?.id"
      >
        <mat-icon
          *ngIf="leftIcon"
          class="left-icon"
          [ngStyle]="leftIconStyle"
          [svgIcon]="leftIcon"
        ></mat-icon>
        <div class="d-contents" [innerHTML]="renderDocumentItem(document, $index) | safeHtml"></div>
        <mat-icon
          *ngIf="rightIcon"
          class="position-relative"
          [ngStyle]="rightIconStyle"
          [svgIcon]="rightIcon"
        ></mat-icon>
      </div>
      }
    </ng-container>
    } @else {
    <ng-container [ngTemplateOutlet]="documentStateTemplate"></ng-container>
    }
  </div>

  }
</div>

<!-- Defined once so the vertical list and the horizontal carousel render the same configured
     fetching and no-document templates, skeleton included. -->
<ng-template #documentStateTemplate>
  @if (isApiInProgress || appBuilderShowFetchingContent) {
  <div class="w-100" [innerHTML]="fetchingTemplate | safeHtml"></div>
  } @else {
  <div class="w-100" [innerHTML]="noDocumentTemplate | safeHtml"></div>
  }
</ng-template>
